import * as Colours from "../../../../../../../globalStyles/colors";

export const body = {
    paddingLeft: "30px",
    paddingRight: "30px",
    paddingTop: "30px"
};

export const usersContainer = {
    height: "400px",
    overflowY: "scroll"
};

export const topButtonColumn = {
    paddingRight: "0",
    paddingLeft: "0"
};

export const topButtons = {
    textAlign: "center",
    background: "white",
    borderRadius: "25px 25px 0 0",
    cursor: "pointer"
};

export const topButtonSelected = {
    textAlign: "center",
    background: Colours.primary,
    color: "white",
    fontWeight: "bold",
    borderRadius: "25px 25px 0 0",
    borderTop: "2px solid black",
    borderLeft: "2px solid black",
    borderRight: "2px solid black",
    cursor: "pointer"
};

export const tabContainer = {
    paddingTop: "30px"
};

export const featureText = {
    color: "red",
    fontWeight: "bold"
};

export const spUserCross = {
    cursor: "pointer"
};

export const columnRight = {
    textAlign: "right"
};

export const questionCounter = {
    textAlign: "right",
    color: "red"
};

export const contactOfDepartmentText = {
    fontWeight: "bold"
};
